import upperCaseFirstLetter from './upperCaseFirstLetter';

const beautifyEnumString = (text: string) => upperCaseFirstLetter(text).replaceAll('_', ' ');

export default beautifyEnumString;
